/* eslint-disable no-param-reassign */
import { createEntityReducer } from 'util/reducers'

import {
  CREATE_CONTACT_STARTED,
  CREATE_CONTACT_SUCCESS,
  CREATE_CONTACT_FAILED,
  CHANGE_CONVERSATION_CONTACT_FAILED,
} from '../types'

export default createEntityReducer('contacts', {
  transformEntity: contact => {
    const newContact = { ...contact }
    if (newContact.customFieldValues && newContact.customFieldValues.nodes) {
      newContact.customFieldValues = newContact.customFieldValues.nodes.reduce(
        (result, fieldValue) => {
          const {
            key: valueKey, // This is actually the custom field key but sometimes it is on the value
            customField: { isArray, key = valueKey } = {},
            mode,
            ...rest
          } = fieldValue
          const existingValue = result[key]
          if (isArray) {
            rest.value = [...(existingValue?.value || []), rest.value]
          }
          result[key] = { key, ...rest }
          return result
        },
        {}
      )
    }
    if (newContact.companies) {
      newContact.companies = newContact.companies.nodes
    }
    return newContact
  },
  reduce: (draftState, { type, meta: { contactIdOrTemp } = {} }) => {
    if (!contactIdOrTemp) return

    if (type === CREATE_CONTACT_STARTED) {
      draftState[contactIdOrTemp].isCreating = true
    } else if (type === CREATE_CONTACT_SUCCESS) {
      draftState[contactIdOrTemp].isCreating = false
    } else if (
      [CREATE_CONTACT_FAILED, CHANGE_CONVERSATION_CONTACT_FAILED].includes(type)
    ) {
      draftState[contactIdOrTemp].isCreating = false
    }
  },
})
